
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intelligence/reports",
      function () {
        return require("private-next-pages/intelligence/reports/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/intelligence/reports"])
      });
    }
  